import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

/**
 * @param {{ id: string }} params
 */
export const rebuildScheduleResolution = api(async function rebuildScheduleResolution({ id }) {
    return mutate(
        gql`
            mutation RebuildScheduleResolution($id: ID!) {
                rebuildScheduleResolution(id: $id)
            }
        `,
        { id },
        { returns: "rebuildScheduleResolution" }
    )
})
